import React from 'react';
import { Link } from 'react-router-dom';
import style from './topBarCompoStyle.module.css';
class TopBarCompo extends React.Component {
  // constructor() {
  //   super();
  //   this.state = {
  //     show: true,
  //     scrollPosition: 0,
  //   };
  // }
  // componentDidMount() {
  //   window.addEventListener('scroll', this.handleScroll);
  // }
  // componentWillUnmount() {
  //   window.removeEventListener('scroll', this.handleScroll);
  // }
  // handleScroll = () => {
  //   this.setState({
  //     scrollPosition: document.body.getBoundingClientRect().top,
  //     show:
  //       document.body.getBoundingClientRect().top > this.state.scrollPosition,
  //   });
  // };
  render() {
    //console.log(this.state);
    return (
      // <div
      //   className={this.state.show ? `${style.active} ` : ` ${style.hidden} `}
      // >
      <nav className={`${style.navbar1} navbar bg-success`}>
        <div className={`${style.topbar} container justify-content-star`}>
          <Link className="navbar-brand ms-auto a1" to="/content-video">
            Edukasi Properti
          </Link>
          <a
            className="navbar-brand a2"
            href="https://play.google.com/store/apps/details?id=id.asc.sepakat"
            target="_blank"
            rel="noreferrer"
          >
            Download Apps
          </a>
          <img src={require('../../assets/images/bi_phone.png')} alt="" />
        </div>
      </nav>
      // </div>
    );
  }
}
export default TopBarCompo;
